import rose from '../Palettes/rose';
import grey from '../Palettes/grey';
import colors from './colors';

const gradients = {
  DEFAULT: `${rose[400]}, ${rose[600]}`,
  subtle: `${rose[500]}, ${rose[600]}`,
  executive: `${colors.black}, ${grey[850]}`,
};

export default gradients;
